import React, { useContext } from 'react'
import { CSSTransition } from 'react-transition-group'
import { LawyersContext } from './index'
import CloseCross from './CloseCross'

const fieldsSet = [
	{ key: 'experience', text: '學經歷' },
	{ key: 'specialty', text: '專長' },
	{ key: 'book', text: '著作' }
]

const LawyerDetailed = () => {
	const { opened, closeDetailed, lawyerData } = useContext(LawyersContext)
	return (
		<CSSTransition in={opened} classNames="box" timeout={500}>
			<div className="lawyer-detailed-wrapper">
				<div className="lawyer-detailed-cover" onClick={closeDetailed} />
				<div className="lawyer-detailed-box">
					<img
						className="picture"
						src={lawyerData?.portrait}
						alt={lawyerData?.name}
					/>
					<div className="lawyer-detailed-info">
						<h3>{lawyerData?.name}</h3>
						<h5>{lawyerData?.title}</h5>
						<div className="emailadd">
							<a href={lawyerData?.e_mail} target="_top">
								{lawyerData?.e_mail}
							</a>
						</div>
						{fieldsSet.map(({ key, text }) => {
							if (lawyerData && lawyerData[key]) {
								return (
									<section key={key}>
										<h4>{text}</h4>
										<p dangerouslySetInnerHTML={{ __html: lawyerData[key] }} />
									</section>
								)
							}
						})}
					</div>
					<div className="close-box" onClick={closeDetailed}>
						<CloseCross />
					</div>
				</div>
			</div>
		</CSSTransition>
	)
}
export default LawyerDetailed
